<script setup>
import LogoIcon from '@/components/ui/icons/LogoIcon.vue';
import MobileLogoIcon from '@/components/ui/icons/MobileLogo.vue';

defineProps({
  showAppName: {
    type: Boolean,
    required: false,
    default: true,
  },
});
</script>

<template>
  <div class="logo">
    <MobileLogoIcon class="mobile-logo" />
    <LogoIcon class="desktop-logo" />
  </div>
</template>

<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: center;
  gap: var(--gap-small);
  color: var(--color-background-soft);
  line-height: 24px;
  font-size: 24px;
  font-weight: 800;
  width: 120px;

  @include laptop {
    width: auto;
  }

  &:hover {
    color: var(--accent);
  }

  &__icon {
    width: 62px;
    height: 59px;
    position: relative;
  }
}

.mobile-logo {
  display: none;
}

.desktop-logo {
  display: block;
}
</style>
